<template>
  <div>
    <head>
      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport">
      <meta content="County Health Management System by Nouveta LTD" name="description"/>
      <meta content="Kelvin Njuguna" name="author"/>
      <link href="assets/images/favicon.png" rel="shortcut icon">
      <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>
      <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
      <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css" rel="stylesheet">
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <div id="layout-wrapper">
      <NavigationBar/>

      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">

            <!-- Page Title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">PAID HYGIENE BILLS</h4>
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboards</a></li>
                      <li class="breadcrumb-item active">Paid Bills</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <!-- Summary Cards -->
            <div class="row mb-4">
              <div class="col-xl-3 col-md-6">
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <p class="text-muted fw-medium">Total Bills</p>
                        <h4 class="mb-0">{{ numberFormat(summary.count) }}</h4>
                      </div>
                      <div class="flex-shrink-0 align-self-center">
                        <div class="mini-stat-icon avatar-sm rounded-circle bg-success">
                          <span class="avatar-title">
                            <i class="bx bx-receipt font-size-24"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-md-6">
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <p class="text-muted fw-medium">Total Collected</p>
                        <h4 class="mb-0">KES {{ numberFormat(summary.total) }}</h4>
                      </div>
                      <div class="flex-shrink-0 align-self-center">
                        <div class="mini-stat-icon avatar-sm rounded-circle bg-primary">
                          <span class="avatar-title">
                            <i class="bx bx-money font-size-24"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-md-6">
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <p class="text-muted fw-medium">Displayed Records</p>
                        <h4 class="mb-0">{{ billDetails.length }}</h4>
                      </div>
                      <div class="flex-shrink-0 align-self-center">
                        <div class="mini-stat-icon avatar-sm rounded-circle bg-info">
                          <span class="avatar-title">
                            <i class="bx bx-list-ul font-size-24"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-md-6">
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <p class="text-muted fw-medium">Status</p>
                        <h4 class="mb-0 text-success">PAID</h4>
                      </div>
                      <div class="flex-shrink-0 align-self-center">
                        <div class="mini-stat-icon avatar-sm rounded-circle bg-success">
                          <span class="avatar-title">
                            <i class="bx bx-check-circle font-size-24"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <ToolBarHygiene/>

            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                    <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                      <h4 class="card-title text-capitalize mb-0">
                        <i class="bx bx-check-circle me-2"></i>All Paid Bills
                      </h4>
                      <div class="d-flex">
                        <button @click="exportToCSV" class="btn btn-success btn-sm me-3">
                          <i class="bx bx-download me-1"></i> Export CSV
                        </button>
                        <a v-if="getRight('CREATE BILL')" @click="gotTo('new-bill')"
                           class="btn btn-primary btn-sm" type="button">
                          <i class="mdi mdi-plus-circle-outline font-size-16 me-1"></i>
                          <span>Create A Bill</span>
                        </a>
                      </div>
                    </div>
                  </div>

                  <!-- Filters -->
                  <div class="card-header bg-light pt-3 pb-3">
                    <div class="row g-3">
                      <!-- Search -->
                      <div class="col-md-3">
                        <label class="form-label fw-semibold text-uppercase small">Search</label>
                        <div class="search-box">
                          <div class="position-relative">
                            <input v-model="search" type="text" class="form-control" placeholder="Search bills...">
                            <i class="bx bx-search-alt search-icon"></i>
                          </div>
                        </div>
                      </div>

                      <!-- Date Range -->
                      <div class="col-md-4">
                        <label class="form-label fw-semibold text-uppercase small">Date Range</label>
                        <div class="d-flex align-items-center gap-2">
                          <input class="form-control" type="date" v-model="dateFrom" placeholder="From">
                          <span class="text-muted">to</span>
                          <input class="form-control" type="date" v-model="dateTo" placeholder="To">
                        </div>
                      </div>

                      <!-- Filter Type -->
                      <div class="col-md-2">
                        <label class="form-label fw-semibold text-uppercase small">Filter By</label>
                        <select class="form-select" v-model="filter">
                          <option value="filter-all">All Transactions</option>
                          <option value="filter-sub-county">Sub County</option>
                          <option value="filter-wards">Ward</option>
                          <option value="filer-zone">Zone</option>
                          <option value="filter-officer">Officer</option>
                        </select>
                      </div>

                      <!-- Filter Value -->
                      <div class="col-md-3">
                        <label class="form-label fw-semibold text-uppercase small">Select Option</label>
                        <select class="form-select" v-model="selectedItem">
                          <option :key="index" :value="item.value" v-for="(item, index) in itemList">
                            {{ item.value }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="card-body">
                    <!-- Loading State -->
                    <div v-if="loading" class="text-center py-5">
                      <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      <p class="mt-2">Loading paid bills...</p>
                    </div>

                    <!-- Empty State -->
                    <div v-else-if="billDetails.length < 1" class="text-center py-5">
                      <div class="mb-4">
                        <i class="bx bx-search-alt font-size-64 text-muted"></i>
                      </div>
                      <h5 class="text-muted">No Paid Bills Found</h5>
                      <p class="text-muted">Try adjusting your search or filter criteria</p>
                    </div>

                    <!-- Table -->
                    <div v-else class="table-responsive">
                      <table class="table align-middle table-hover table-nowrap mb-0">
                        <thead class="table-light">
                        <tr>
                          <th class="text-nowrap">NO.</th>
                          <th class="text-nowrap">Bill No</th>
                          <th class="text-nowrap">Description</th>
                          <th class="text-nowrap">Sub County</th>
                          <th class="text-nowrap">Ward</th>
                          <th class="text-nowrap">Zone</th>
                          <th class="text-nowrap">Attendant</th>
                          <th class="text-nowrap text-end">Billed Amount</th>
                          <th class="text-nowrap text-end">Amount Paid</th>
                          <th class="text-nowrap text-end">Balance</th>
                          <th class="text-nowrap">Status</th>
                          <th class="text-nowrap">Date</th>
                          <th class="text-nowrap text-end">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr :key="index" v-for="(item, index) in billDetails" class="hover-row">
                          <td class="text-nowrap">{{ index + 1 }}</td>
                          <td class="text-nowrap">
                            <span class="badge bg-success-subtle text-success">{{ item.billNo }}</span>
                          </td>
                          <td class="text-capitalize">{{ item.feeDescription }}</td>
                          <td class="text-capitalize">{{ item.subCountyName }}</td>
                          <td class="text-capitalize">{{ item.wardName }}</td>
                          <td class="text-capitalize">{{ item.zone }}</td>
                          <td class="text-capitalize">{{ item.names }}</td>
                          <td class="text-end fw-semibold">{{ formatPrice(item.detailAmount) }}</td>
                          <td class="text-end fw-semibold text-success">{{ formatPrice(item.receiptAmount) }}</td>
                          <td class="text-end fw-semibold">{{ formatPrice(item.billBalance) }}</td>
                          <td>
                            <span class="badge bg-success">{{ item.status }}</span>
                          </td>
                          <td class="text-nowrap">{{ formatDateTime(item.dateCreated) }}</td>
                          <td class="text-end">
                            <div class="d-flex justify-content-end gap-1">
                              <button @click="getBill(item.billNo)" class="btn btn-soft-primary btn-sm"
                                      data-bs-toggle="modal" data-bs-target="#billDetail" title="View Details">
                                <i class="bx bx-show"></i>
                              </button>
                              <button @click="printBill(item.billNo)" class="btn btn-soft-success btn-sm" title="Print">
                                <i class="bx bx-printer"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                        <tfoot class="table-dark">
                        <tr>
                          <th colspan="7" class="text-nowrap">{{ billDetails.length }} Bills</th>
                          <td class="text-end fw-semibold">{{ totalDetailAmount }}</td>
                          <td class="text-end fw-semibold">{{ totalReceiptAmount }}</td>
                          <td class="text-end fw-semibold">{{ totalBillBalance }}</td>
                          <th colspan="3"></th>
                        </tr>
                        </tfoot>
                      </table>
                    </div>

                    <!-- Pagination -->
                    <div v-if="billDetails.length > 0" class="row mt-4">
                      <div class="col-sm-12 col-md-5">
                        <div class="dataTables_info">
                          Showing {{ startIndex + 1 }} to {{ Math.min(endIndex, summary.count) }} of {{ summary.count }} entries
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-7">
                        <div class="d-flex justify-content-end align-items-center gap-3">
                          <div class="d-flex align-items-center gap-2">
                            <span class="text-muted small">Rows per page:</span>
                            <select class="form-select form-select-sm" v-model="pageSize" style="width: auto;">
                              <option value="10">10</option>
                              <option value="25">25</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                            </select>
                          </div>
                          <ul class="pagination pagination-rounded mb-0">
                            <li class="page-item" :class="{ disabled: currentPage === 1 }">
                              <a class="page-link" @click="prevPage">
                                <i class="mdi mdi-chevron-left"></i>
                              </a>
                            </li>
                            <li v-for="page in pagination(currentPage, totalPages, 3)" :key="page"
                                class="page-item" :class="{ active: currentPage === page }">
                              <span v-if="page === '...'" class="page-link">{{ page }}</span>
                              <a v-else class="page-link" @click="goToPage(page)">{{ page }}</a>
                            </li>
                            <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                              <a class="page-link" @click="nextPage">
                                <i class="mdi mdi-chevron-right"></i>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- Bill Detail Modal -->
        <div class="modal fade" id="billDetail" tabindex="-1" aria-labelledby="billDetailLabel" aria-hidden="true">
          <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="billDetailLabel">Bill Details - {{ billNo }}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <div class="row mb-4">
                  <div class="col-6">
                    <address>
                      <strong class="text-capitalize">Bill Prepared for:</strong><br>
                      {{ billDetail.description }}<br><br>
                      On {{ formatDateTime(billDetail.dateCreated) }}
                    </address>
                  </div>
                </div>

                <div class="search-box mb-3">
                  <div class="position-relative">
                    <input v-model="keyword" type="text" class="form-control" placeholder="Search businesses...">
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>

                <div class="table-responsive">
                  <table class="table table-nowrap table-hover">
                    <thead class="bg-light">
                    <tr>
                      <th style="width: 20px;"></th>
                      <th>Business ID</th>
                      <th>Business Name</th>
                      <th>Owner</th>
                      <th>Sub Category</th>
                      <th>Sub County</th>
                      <th>Ward</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in businesses" :key="index">
                      <td>
                        <input type="checkbox" :checked="selectedBusinessID === item.businessID"
                               @change="toggleSelection(item.businessID)">
                      </td>
                      <td>{{ item.businessID }}</td>
                      <td>{{ item.businessName }}</td>
                      <td>{{ item.fullNames }} <a href="#">{{ item.ownerPhone }}</a></td>
                      <td>{{ item.businessSubCategory }}</td>
                      <td>{{ item.subCountyName }}</td>
                      <td>{{ item.wardName }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="modal-footer">
                <button v-if="selectedBusinessID != null" @click="generateEntryCert(billDetail.billNo)"
                        class="btn btn-danger btn-sm" data-bs-dismiss="modal">
                  Initiate Inspection
                </button>
                <button @click="printBillModal()" class="btn btn-primary btn-sm">
                  <i class="mdi mdi-printer me-2"></i> Print Bill
                </button>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6"></div>
              <div class="col-sm-6">
                <div class="text-sm-end d-sm-block">Developed by County</div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import {authUrl, biller, execute, fire, getRight} from "@/api";
import NavigationBar from "@/components/Navigation";
import router from "@/router";
import ToolBarHygiene from "@/components/hygiene/ToolBarHygiene.vue";

export default {
  name: "HygienePaidBills",
  components: {ToolBarHygiene, NavigationBar},
  data() {
    return {
      keyword: '',
      selectedFeeID: null,
      selectedBusinessID: null,
      search: '',
      loading: false,
      currentPage: 1,
      totalPages: 0,
      pageSize: 25,
      summary: {
        count: 0,
        total: 0
      },
      totalAmount: null,
      selectedItem: null,
      itemList: [{id: null, value: null}],
      filter: 'filter-all',
      dateFrom: '',
      dateTo: '',
      message: '',
      billDetails: [],
      billDetail: {},
      billNo: '',
      businesses: []
    }
  },
  watch: {
    pageSize(newPageSize) {
      this.getBills("");
      const totalItems = this.summary.count;
      const newTotalPages = Math.ceil(totalItems / newPageSize);
      this.totalPages = newTotalPages;
      this.currentPage = 1;
    },
    search() {
      this.getBills(this.search);
    },
    keyword() {
      this.getBusinesses(this.keyword);
    },
    selectedItem(newValue) {
      this.getBills(newValue);
    },
    dateFrom(newValue) {
      if (this.dateFrom !== '' && this.dateTo !== '') {
        this.getBills("PUBLIC-HEALTH");
      }
    },
    dateTo(newValue) {
      if (this.dateFrom !== '' && this.dateTo !== '') {
        this.getBills("PUBLIC-HEALTH");
      }
    },
    filter(newValue) {
      if (newValue === 'filter-all') {
        this.getBills("PUBLIC-HEALTH");
      } else if (newValue === 'filter-sub-county') {
        this.getSubCounties();
      } else if (newValue === 'filter-wards') {
        this.getWards();
      } else if (newValue === 'filer-zone') {
        this.getZones();
      } else if (newValue === 'filter-officer') {
        this.getUsers();
      }
    }
  },
  computed: {
    startIndex() {
      return (this.currentPage - 1) * this.pageSize;
    },
    endIndex() {
      return this.currentPage * this.pageSize;
    },
    totalReceiptAmount() {
      return this.formatPrice(this.billDetails.reduce((sum, billDetail) => sum + parseInt(billDetail.receiptAmount), 0));
    },
    totalBillBalance() {
      return this.formatPrice(this.billDetails.reduce((sum, billDetail) => sum + parseInt(billDetail.billBalance), 0));
    },
    totalDetailAmount() {
      return this.formatPrice(this.billDetails.reduce((sum, billDetail) => sum + parseInt(billDetail.detailAmount), 0));
    }
  },
  mounted() {
    this.menuAccess();
    this.getBills("PUBLIC-HEALTH");
  },
  methods: {
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Hygiene Paid Bill");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller).catch((e) => console.error('Menu access error:', e.message));
    },
    toggleSelection(businessID) {
      this.selectedBusinessID = (this.selectedBusinessID === businessID) ? null : businessID;
    },
    getRight(type) {
      return getRight(type);
    },
    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);
      if (start < 1) {
        start = 1;
        end = start + maxVisibleButtons - 1;
        if (end > totalPages) end = totalPages;
      }
      if (end > totalPages) {
        end = totalPages;
        start = end - maxVisibleButtons + 1;
        if (start < 1) start = 1;
      }
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      if (start > 1) pages.unshift("...");
      if (end < totalPages) pages.push("...");
      return pages;
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getBills("PUBLIC-HEALTH");
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getBills("PUBLIC-HEALTH");
      }
    },
    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getBills("PUBLIC-HEALTH");
      }
    },
    numberFormat(num) {
      if (!num) return '0';
      return new Intl.NumberFormat("en-GB").format(num);
    },
    formatPrice(value) {
      return new Intl.NumberFormat('en-KE', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      }).format(value);
    },
    formatDateTime(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleString('en-KE', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    gotTo(route) {
      router.push(route);
    },
    getBills(keyword) {
      this.billDetails = [];
      this.loading = true;
      const data = new FormData();
      data.append("function", "getBillsPaginate");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("status", "PAID");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("keyword", "PUBLIC-HEALTH");
      execute(data, biller)
          .then((res) => {
            this.loading = false;
            this.summary.count = 0;
            this.summary.total = 0;
            if (res.data.success) {
              this.billDetails = res.data.data.billDetails;
              this.summary = res.data.data.summary;
              this.totalPages = Math.ceil(this.summary.count / this.pageSize);
              this.totalAmount = this.billDetails.reduce((acc, cur) => {
                let receiptAmount = Number(cur.receiptAmount);
                return acc + receiptAmount;
              }, 0);
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.loading = false;
            this.message = e.message;
          });
    },
    getBusinesses(keyword) {
      const data = new FormData();
      data.append("function", "getBusinesses");
      data.append("keyword", keyword);
      execute(data, fire)
          .then((res) => {
            if (res.data.success) {
              this.businesses = res.data.data.businesses;
            }
          })
          .catch((e) => console.error('Error:', e.message));
    },
    getBill(billNo) {
      this.billNo = billNo;
      const data = new FormData();
      data.append("function", "getBill");
      data.append("billNo", billNo);
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.billDetail = res.data.data.billDetails;
            }
          })
          .catch((e) => console.error('Error:', e.message));
    },
    generateEntryCert(billNo) {
      const data = new FormData();
      data.append("function", "generateFireEntryCert");
      data.append("billNo", billNo);
      data.append("businessID", this.selectedBusinessID);
      execute(data, biller)
          .then((res) => alert(res.data.message))
          .catch((e) => alert('Error: ' + e.message));
    },
    printBill(billNo) {
      localStorage['params'] = JSON.stringify({billNo: billNo});
      const routeData = this.$router.resolve({name: 'bill'});
      window.open(routeData.href, '_blank');
    },
    printBillModal() {
      this.printBill(this.billDetail.billNo);
    },
    exportToCSV() {
      try {
        const headers = ['No', 'Bill No', 'Description', 'Sub County', 'Ward', 'Zone', 'Attendant', 'Billed Amount', 'Amount Paid', 'Balance', 'Status', 'Date'];
        const rows = this.billDetails.map((item, index) => [
          index + 1,
          item.billNo || '',
          item.feeDescription || '',
          item.subCountyName || '',
          item.wardName || '',
          item.zone || '',
          item.names || '',
          item.detailAmount || 0,
          item.receiptAmount || 0,
          item.billBalance || 0,
          item.status || '',
          item.dateCreated || ''
        ]);
        let csvContent = headers.join(',') + '\n';
        rows.forEach(row => {
          const escapedRow = row.map(field => {
            const stringField = String(field);
            if (stringField.includes(',') || stringField.includes('"') || stringField.includes('\n')) {
              return `"${stringField.replace(/"/g, '""')}"`;
            }
            return stringField;
          });
          csvContent += escapedRow.join(',') + '\n';
        });
        csvContent += '\n';
        csvContent += `Total Records,${this.billDetails.length}\n`;
        csvContent += `Total Amount,KES ${this.numberFormat(this.summary.total)}\n`;
        const blob = new Blob([csvContent], {type: 'text/csv;charset=utf-8;'});
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `paid-hygiene-bills-${new Date().toISOString().split('T')[0]}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        alert(`Successfully exported ${this.billDetails.length} records to CSV`);
      } catch (error) {
        console.error('Export error:', error);
        alert('Error exporting data to CSV. Please try again.');
      }
    },
    getSubCounties() {
      this.itemList = [];
      const data = new FormData();
      data.append("function", "getSubCounty");
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              for (let i = 0; i < res.data.data.length; i++) {
                let subCounty = res.data.data[i];
                this.itemList.push({id: subCounty.subCountyID, value: subCounty.subCountyName});
              }
            }
          })
          .catch((e) => console.error('Error:', e.message));
    },
    getWards() {
      this.itemList = [];
      const data = new FormData();
      data.append("function", "getWards");
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              for (let i = 0; i < res.data.data.length; i++) {
                let ward = res.data.data[i];
                this.itemList.push({id: ward.wardID, value: ward.wardName});
              }
            }
          })
          .catch((e) => console.error('Error:', e.message));
    },
    getZones() {
      this.itemList = [];
      const data = new FormData();
      data.append("function", "getZones");
      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              for (let i = 0; i < res.data.data.zones.length; i++) {
                let zone = res.data.data.zones[i];
                this.itemList.push({id: zone.id, value: zone.zone});
              }
            }
          })
          .catch((e) => console.error('Error:', e.message));
    },
    getUsers() {
      this.itemList = [];
      const data = new FormData();
      data.append("function", "getUsers");
      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              for (let i = 0; i < res.data.data.users.length; i++) {
                let user = res.data.data.users[i];
                this.itemList.push({id: user.id, value: user.names});
              }
            }
          })
          .catch((e) => console.error('Error:', e.message));
    }
  }
}
</script>

<style scoped>
.mini-stats-wid .card-body {
  padding: 20px;
}

.mini-stat-icon {
  width: 48px;
  height: 48px;
}

.hover-row {
  transition: all 0.3s ease;
  cursor: pointer;
}

.hover-row:hover {
  background-color: #f8f9fa !important;
  transform: translateX(2px);
}

.btn-soft-primary {
  color: #556ee6;
  background-color: rgba(85, 110, 230, 0.18);
  border: none;
}

.btn-soft-primary:hover {
  color: #fff;
  background-color: #556ee6;
}

.btn-soft-success {
  color: #34c38f;
  background-color: rgba(52, 195, 143, 0.18);
  border: none;
}

.btn-soft-success:hover {
  color: #fff;
  background-color: #34c38f;
}

.bg-success-subtle {
  background-color: rgba(52, 195, 143, 0.18);
  color: #34c38f;
}

.search-box .search-icon {
  position: absolute;
  left: 13px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  color: #74788d;
}

.search-box .form-control {
  padding-left: 40px;
}

@media (max-width: 768px) {
  .table-responsive {
    font-size: 0.875rem;
  }

  .btn-sm {
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
  }
}
</style>